import { FormattedMessage, useIntl } from "react-intl";
import { Genders } from "~enums/genders";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
  value?: string;
  placeholder?: string;
  multiple?: boolean;
  defaultValue?: string | { value: string; label: string }[];
};

const SelectPersonGender = ({ className, disabled, onChange, value, placeholder, multiple, defaultValue }: Props) => {
  const { formatMessage } = useIntl();

  const options = [
    { value: Genders.Female, label: formatMessage({ id: `gender.${Genders.Female}` }) },
    { value: Genders.Male, label: formatMessage({ id: `gender.${Genders.Male}` }) },
    { value: Genders.Unknown, label: formatMessage({ id: `gender.${Genders.Unknown}` }) },
  ];

  return (
    <CustomSelect
      style={{ minWidth: "130px" }}
      value={value}
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          onChange?.(option as { value: string; label: string }[]);
        } else {
          onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={placeholder || <FormattedMessage id="gender" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectPersonGender;
